import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import routerPaths from '../util/routerPaths';
import { getLogger } from '../../util/logger';
import { useAuth } from '../hooks/useAuth';
import useTheme from '../hooks/useTheme';

const logger = getLogger('LocalLogin');

const handleClick = async (routerHistory, auth) => {
  logger.debug('logging in');

  await fetch('/login', { method: 'POST' });
  await auth.getTenantProfile();
  routerHistory.push(routerPaths.HOME);
};

function LocalLogin() {
  const auth = useAuth();
  const history = useHistory();
  const [theme] = useTheme();

  return (
    <Button
      variant={theme?.buttonVariant}
      onClick={() => handleClick(history, auth)}
    >
      Local Login
    </Button>
  );
}

export default LocalLogin;
